import { GET_EVENTS_SUCCESS } from './types';
import { BASE_URL } from '../index';

const initialState = {
  events: [],
};

const sortBy = (term, decending = true) => (a, b) =>
  decending ? b[term] - a[term] : a[term] - b[term];

const addBaseUrl = event =>
  !BASE_URL
    ? event
    : Object.assign({}, event, {
        thumbnail: BASE_URL + event.thumbnail,
        images: event.images.map(i => ({
          src: BASE_URL + i.src,
          caption: i.caption,
        })),
      });

function reducer(state = initialState, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.data
          .filter(e => e.timeline === true)
          .map(addBaseUrl)
          .sort(sortBy('year')),
      };
    default:
      return state;
  }
}

export { reducer as default };



// WEBPACK FOOTER //
// ./src/timeline/reducer.js